(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/constants.js');
(function(svs) {
  'use strict';


  svs.matchen = svs.matchen || {};

  svs.matchen.STORAGE_NAME = 'Matchen';
  svs.matchen.TIPSINFO = 'tipsInfo';
  svs.matchen.COUPON = 'coupon';
  svs.matchen.XPERTEN = 'xperten';
  svs.matchen.STORAGE_TIMEOUT = 2628000;

  if (typeof exports !== 'undefined') {
    module.exports = svs.matchen;
  }
})(svs);


 })(window);